import React from 'react';
import {OutlinedTextFieldProps} from '@mui/material';
import FormikTextField from 'components/inputs/FormikTextField';

type Props = Partial<OutlinedTextFieldProps> & {
   name: string;
   min?: number;
   max?: number;
   variant?: 'outlined';
};
const FormikNumberField = (props: Props) => {
   const type = 'number';
   return <FormikTextField {...props} type={type} />;
};
export default React.memo(FormikNumberField);
